import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { MetaPixelTracker } from './components/MetaPixelTracker';
import { Disclaimer } from './pages/Disclaimer';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { RefundPolicy } from './pages/RefundPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
export function App() {
  return <BrowserRouter data-id="element-0">
      <MetaPixelTracker data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
        <Route path="/politica-de-privacidad" element={<PrivacyPolicy data-id="element-6" />} data-id="element-5" />
        <Route path="/terminos-y-condiciones" element={<TermsAndConditions data-id="element-8" />} data-id="element-7" />
        <Route path="/politica-de-reembolsos" element={<RefundPolicy data-id="element-10" />} data-id="element-9" />
        <Route path="/descargo-de-responsabilidad" element={<Disclaimer data-id="element-12" />} data-id="element-11" />
      </Routes>
    </BrowserRouter>;
}